import compose from 'recompose/compose'
import withState from 'recompose/withState'
import withProps from 'recompose/withProps'
import withHandlers from 'recompose/withHandlers'

import View from './LeavesReporter'

function buildUrl (url, query) {
  if (!query) return url

  const queries = []
  Object.keys(query).forEach(key => {
    if (query[key] === undefined) return
    queries.push(`${key}=${encodeURIComponent(JSON.stringify(query[key]))}`)
  })

  return `${url}?${queries.join('&')}`
}


const LeavesReporter = compose(
  withState('query', 'setQuery', {}),

  withProps({
    fields: ['date'],
    schema: {
      type: 'object',
      contents: {
        date: {
          name: '統計區間',
          type: 'Date',
          format: 'YYYY/MM/DD',
        },
      },
    },
  }),
  withHandlers({
    download: ({ query }) => () => {
      const url = buildUrl('api/print/leaves/xlsx', { query })
      window.open(url, '_blank')
    },
  }),
)(View)

LeavesReporter.displayName = 'LeavesReporter'

export default LeavesReporter



// WEBPACK FOOTER //
// ./src/components/LeavesReporter/index.js